import { ClientConfigFactory } from './clientConfig.factory';
import { IClientConfig, IPresentationConfig } from './clientConfig';

export function extractPresentationConfig(clientConfig: IClientConfig): IPresentationConfig {
    if (clientConfig.domainPages && clientConfig.domainPages[window.location.hostname]) {
        return clientConfig.domainPages[window.location.hostname].presentationConfig;
    }

    return clientConfig.presentationConfig;
}

export default async function getClientConfig(clientId: string) {
    function getClientsConfig() {
        return fetch(`${process.env.PUBLIC_URL}/config/clientConfig.json`).then((response) =>
            response.json(),
        );
    }

    const CLIENTS_CONFIG = await getClientsConfig();
    const clientConfigJSON = CLIENTS_CONFIG[clientId];
    return ClientConfigFactory.makeClientConfig(clientConfigJSON);
}
